import axios from 'axios';

export default {
    state: {
        accountantsDic: null,
    },
    getters: {
        getAccountantsDic(state) {
            return state.accountantsDic
        },
    },
    mutations: {
        setAccountantsDic(state, data) {
            return state.accountantsDic = data
        },
    },
    actions: {
        accountantsDicRequest(context) {
            return axios.get('/api/dictionaries/accountants')
                .then(res => {
                    context.commit('setAccountantsDic', res.data)
                })
        },
    }
}